import type { SafeHtmlAttributes } from "@core/types/SafeHtmlAttributes";
import classnames from "classnames";

import styles from "./Separator.module.scss";

export type SeparatorTextProps = {
  text?: string;
} & SafeHtmlAttributes<HTMLDivElement>;

export type SeparatorWithoutTextProps = {
  text: never;
} & SafeHtmlAttributes<HTMLHRElement>;

export type SeparatorProps = SeparatorTextProps | SeparatorWithoutTextProps;

export const Separator = ({ text, ...rest }: SeparatorProps) => {
  if (!text) {
    return <hr className={classnames(styles.separator)} {...rest} />;
  }

  return (
    <div className={classnames(styles.separator, styles.withText)} role="separator" {...rest}>
      <span className={styles.line} aria-hidden="true" />
      <span className={styles.text}>{text}</span>
      <span className={styles.line} aria-hidden="true" />
    </div>
  );
};
